import { render, staticRenderFns } from "./CredentialCopyStorage.vue?vue&type=template&id=4a91a12e&scoped=true&"
import script from "./CredentialCopyStorage.vue?vue&type=script&lang=js&"
export * from "./CredentialCopyStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91a12e",
  null
  
)

export default component.exports